import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-tutorial',
  imports: [TranslatePipe, MatButtonModule],
  templateUrl: './tutorial.component.html',
  styleUrl: './tutorial.component.scss'
})
export class TutorialComponent {
  private readonly router = inject(Router);

  protected onClickContinue() {
    this.router.navigateByUrl('exhibition');
  }

}
